export {default} from '../../../core/components/Repository/FieldTextAreaJoin';